import styles from './index.module.css';

export const PageLoading = () => {
  return <div className={styles.pageLoading} />;
};
